export class FormAPIError {
  status: number;
  errors: Record<string, string[]>;

  constructor(status: number, errors: Record<string, string[]>) {
    this.status = status;
    this.errors = errors;
  }
}
